<template>
  <v-container id="endpoint" fluid tag="section">
    <v-row>
      <v-col cols="2">
        <v-btn
          color="primary"
          @click="$refs.systemEndpointInfoDialog.dialog = true"
        >
          {{ $t("endpoint") }} {{ $t("information") }}
        </v-btn>

        <SystemEndpointInfoDialog
          ref="systemEndpointInfoDialog"
        ></SystemEndpointInfoDialog>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <base-material-card color="primary">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">{{ $t("endpoint") }}</div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        v-model="endpointData.url"
                        :label="$t('add') + ' ' + $t('endpoint')"
                        :hint="$t('endpointHint')"
                        :rules="rules.endpoint"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="3">
                      <v-btn @click="addEndpoint(endpointData.url)">
                        {{ $t("add") }}
                      </v-btn>
                    </v-col>

                    <v-spacer></v-spacer>

                    <v-col cols="3">
                      <v-btn
                        @click="
                          confirmFunction(
                            $t('deleteConfirm'),
                            removeEndpoints,
                            selected
                          )
                        "
                      >
                        {{ $t("delete") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-data-table
                    :headers="headers"
                    v-model="selected"
                    :items="endpointItems"
                    item-key="_id"
                    :items-per-page="5"
                    :footer-props="{
                      showFirstLastPage: true,
                      firstIcon: 'mdi-arrow-collapse-left',
                      lastIcon: 'mdi-arrow-collapse-right',
                      prevIcon: 'mdi-minus',
                      nextIcon: 'mdi-plus',
                    }"
                    show-select
                  >
                    <template v-slot:[`item.accept`]="{ item }">
                      <v-checkbox v-model = "item.accept" :ripple = "false" @change="updateEndpoint(item)">
                      </v-checkbox>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-icon
                        small
                        @click="
                          confirmFunction(
                            $t('deleteConfirm'),
                            removeEndpoints,
                            [item]
                          )
                        "
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SystemEndpointInfoDialog from "@/components/system/SystemEndpointInfoDialog";
import {
  getEndPoints,
  addEndpoint,
  removeEndpoints,
  updateEndpoint,
} from "@/endpoint/endpoint";
import { confirmFunction } from "@/plugins/util";

export default {
  name: "EndPoint",
  components: {
    SystemEndpointInfoDialog,
  },
  data() {
    return {
      headers: [
        { text: this.$t("url"), value: "url" },
        { text: this.$t("accept"), value:"accept", sortable: false },
        { text: this.$t("action"), value: "action", sortable: false },
      ],
      rules: {
        endpoint: [
          (v) => !!v || this.$t("rule-required"),
          (v) =>
            (v != null && v.startsWith("http")) ||
            this.$t("rule-endpoint-format"),
        ],
      },
      selected: [],
      endpointData: {
        url: null,
      },
      endpointItems: [],
    };
  },
  created() {
    this.init(this);
  },
  methods: {
    confirmFunction: confirmFunction,
    async init(scope) {
      scope.endpointItems = await getEndPoints();

      return scope;
    },
    addEndpoint(url) {
      addEndpoint(url).then(() => {
        this.$router.go();
      });
    },
    removeEndpoints(endpoints) {
      removeEndpoints(endpoints).then(() => {
        this.$router.go();
      });
    },
    updateEndpoint(endpoint){
      let data = new FormData()
      console.log(endpoint._id)
      console.log(endpoint.url)
      console.log(endpoint.accept)
      data.append("_id",endpoint._id)
      data.append("url",endpoint.url)
      data.append("accept",endpoint.accept)
      updateEndpoint(data).then(() => {
        console.log("update success")
        // this.$router.go()
      })
    }
  },
};
</script>
